import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import BaseContentLayer from './BaseContentLayer';

interface Props {
  contentColor: LuiV3ColorKey;
}

const TextContentLayer = styled(BaseContentLayer)<Props>`
  --btn-internals-full-padding: calc(var(--btn-size) / 4);
  --btn-internals-thin-padding: 0;
  --badge-default-color: var(--theme-color-secondaryContainer);
  --badge-default-font-color: var(--theme-color-onSecondaryContainer);
  color: ${({contentColor}) => Luiv3Constants.baseColor[contentColor]};
`;

export default TextContentLayer;
